<template>
  <div class="noapply">
    <img src="@/assets/images/policy/apply_kunming.png" alt="" class="banner" />
    <div class="main-width">
      <div class="noapply-title m_t45">无申请兑现自动核验结果信息</div>
      <div class="noapply-banner-wrapper m_t30">
        <div class="noapply-banner">
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            兑现内容
          </div>
          <div class="noapply-banner-content">
            <div class="p_l60">
              {{ detailsData.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="noapply-banner-wrapper m_t30">
        <div class="noapply-banner">
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            奖励金额
          </div>
          <div class="noapply-banner-content">
            <div class="p_l60">{{ detailsData.amount }}元</div>
          </div>
        </div>
      </div>
      <div class="noapply-banner-wrapper m_t30">
        <div class="noapply-banner">
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            企业银行账号信息
            <img
              src="@/assets/images/icon/noapply/doing_icon.png"
              alt=""
              style="width: 32px;margin-left: 10px;"
              @click="actVisible = true"
            />
          </div>
          <div class="noapply-banner-content">
            <div class="p_l60"></div>
            <div class="banner-form m_t30">
              <div class="banner-form-content">
                <el-form>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="账户名：">
                        {{ bankForm.accountName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="账号：">
                        {{ bankForm.accountNumber }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="开户银行：">
                        {{ bankForm.bankName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系人：">
                        {{ bankForm.contacts }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话：">
                        {{ bankForm.contactsPhone }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="会计负责人：">
                        {{ bankForm.accounting }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出纳负责人：">
                        {{ bankForm.cashier }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="noapply-banner-wrapper m_t30">
        <div class="noapply-banner">
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            承诺函
          </div>
          <div class="noapply-banner-content">
            <div class="p_l60 color_blue pointer">
              {{ basicInfo.company }}信用承诺书
            </div>
          </div>
        </div>
      </div>
      <div class="noapply-banner-wrapper m_t30">
        <div class="noapply-banner">
          <div class="noapply-banner-title m_t30 m_b30 font-bold">
            佐证材料信息
          </div>
          <div class="noapply-banner-content">
            <p class="p_l60">
              <i class="el-icon-circle-check icon_true"></i>
              1、新认定的国家高新企业
            </p>
            <p class="p_l60">
              <i class="el-icon-circle-close icon_true"></i> 
              <i class="el-icon-circle-check icon_true"></i>
              2、国家高新企业认定证书
            </p>
          </div>
        </div>
      </div> -->
      <div class="deal-btn">
        <el-button
          type="primary"
          @click="
            $router.push({
              name: 'ApplyNo',
            })
          "
        >
          确定
        </el-button>
        <el-button
          @click="
            $router.push({
              name: 'PcmNoApply',
            })
          "
        >
          取消
        </el-button>
      </div>
    </div>
    <!-- 信用承诺书 -->
    <el-dialog
      v-if="promiseVisible"
      class="dialog"
      :visible.sync="promiseVisible"
      @close="handleClosePromise"
      width="60%"
      :before-close="handleClosePromise"
    >
      <template #title>
        <div class="tc font-20">信用承诺书</div>
      </template>
      <div class="wrapper">
        <!-- <div class="font-bold font-16">本公司承诺:</div> -->
        <!-- <div class="font-16 m_t20 lh1_5">
					&nbsp;&nbsp;我公司（单位）不属于失信被执行人、联合惩戒、重大税收违反对象；企业及法定代表人从未参与涉黑涉恶违法犯罪。如若违反以上承诺，我公司（单位）愿意承担由此造成的一切法律责任。我公司（单位）授权并统一市工业和信息化局查询我公司（单位）申报本次扶持政策所需要的信用报告等相关资信情况
        </div>-->
        <div class="font-16 m_t10 lh_2 indent_2">
          为加快推进全国，加强企业诚信自律，逐步建立企业诚信经营长效机制，营造诚实守信的信用环境，树立诚信守法经营形象。我单位
          <span class="under-line"></span>
          ，统一社会信用代码为
          <span class="under-line"></span>
          ，郑重承诺如下：
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （一）严格遵守国家法律、法规、规章和政策规定，依法从事生产经营活动。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （二）自觉接受政府、行业组织、社会公众、新闻舆论的监督，积极履行社会责任。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （三）自我约束、自我管理，守合同、重信用，不制假售假、商标侵权、虚假宣传、违约毁约、恶意逃债、偷税漏税、价格欺诈、垄断和不正当竞争，切实维护消费者的合法权益。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （四）发生违法失信行为，依照有关法律、行政法规规定接受行政执法部门给予的行政处罚、约束和惩戒，并依法承担相应责任。
        </div>
        <div class="font-16 m_t10 lh_2 indent_2">
          （五）本《信用承诺书》同意向社会公开。
        </div>
        <div class="footer-box m_t20">
          <div class="flex-end end-box">
            <div class="font-16 m_t10 lh1_5 flex-width">
              <span>承诺单位：</span>
              <span class="text-box"></span>
            </div>
          </div>
          <div class="flex-end end-box">
            <div class="font-16 m_t10 lh1_5 flex-width">
              <span>法定代表人：</span>
              <span class="text-box"></span>
            </div>
          </div>

          <div class="font-16 m_t10 lh1_5">2021年12月13日</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePromise()">取 消</el-button>
        <el-button
          type="primary"
          @click="
            handleClosePromise();
            checked = true;
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 编辑账户信息 -->
    <el-dialog
      v-if="actVisible"
      title="编辑账户信息"
      class="dialog"
      :visible.sync="actVisible"
      @close="handleCloseAccount"
      width="60%"
      :before-close="handleCloseAccount"
    >
      <div class="banner-form">
        <div class="banner-form-content">
          <el-form
            @submit.native.prevent
            :rules="rules"
            ref="form-bank"
            :model="actForm"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="账户名" prop="accountName">
                  <el-input v-model="actForm.accountName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号" prop="accountNumber">
                  <el-input v-model="actForm.accountNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <div style="width: calc(50% - 10px)">
                  <el-form-item label="开户银行" prop="bankName">
                    <el-input v-model="actForm.bankName"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人" prop="contacts">
                  <el-input v-model="actForm.contacts"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="contactsPhone">
                  <el-input v-model="actForm.contactsPhone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="会计负责人" prop="accounting">
                  <el-input v-model="actForm.accounting"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出纳负责人" prop="cashier">
                  <el-input v-model="actForm.cashier"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAccount()">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBank()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { FormValid } from "@/config";
import { deepClone } from "@/common/utils";
import { getById } from "@/api/noApply";

export default {
  data() {
    return {
      checked: false,
      promiseVisible: false,
      detailsData: {},
      bankForm: {
        accountName: "中投国信（北京）科技发展有限公司",
        accountNumber: "11102938393930",
        bankName: "中国工商银行(黄石天津路支行)",
        contacts: "鞠庆煌",
        contactsPhone: "13876547464",
        accounting: "鞠庆煌",
        cashier: "卢明江",
      },
      actForm: {},
      actVisible: false,
      rules: {
        cashier: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
        ],
        accountingName: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
          { validator: FormValid.name },
        ],
        contactsPhone: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 13,
          },
          { validator: FormValid.phone1 },
        ],
        contacts: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
          { validator: FormValid.name },
        ],
        bank: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        bankNumber: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
            max: 20,
          },
          { validator: FormValid.number },
        ],
        bankAccount: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
      basicInfo: {},
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.basicInfo = JSON.parse(localStorage.getItem("basic"));
    this.bankForm.accountName = this.basicInfo.nickName;
    this.actForm = deepClone(this.bankForm);
  },
  methods: {
    getData() {
      getById({
        id: this.$route.query.id,
      })
        .then((res) => {
          let { code, result, msg } = res.data;
          this.detailsData = result;
          if (code === 200) {
          }
        })
        .finally(() => (this.loading = false));
    },
    showPromise() {
      this.promiseVisible = true;
    },
    handleClosePromise() {
      this.promiseVisible = false;
    },
    handleCloseAccount() {
      this.actForm = deepClone(this.bankForm);
      this.actVisible = false;
    },
    handleConfirmBank() {
      this.bankForm = deepClone(this.actForm);
      this.$message.success("编辑成功");
      this.actVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content,
/deep/.el-form-item__label {
  font-size: 16px;
}
.banner-form {
  border: 1px solid #eee;
  min-height: 260px;
  &-label {
    display: flex;
    background: #f6f8fa;
    color: #333;
    font-weight: bold;
    padding: 10px 20px;
    border: 1px solid #eee;
  }
  &-content {
    padding: 10px 20px 0;
  }
  &-none {
    color: #ccc;
    text-align: center;
    height: 100%;
    cursor: pointer;
    font-size: 20px;
  }
}
.noapply-title {
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  color: #333;
  margin-top: 34px;
  font-weight: bold;
}
.noapply-branch {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #aaa;
}
.noapply-banner-title {
  position: relative;
  font-size: 18px;
  padding-left: 20px;
  font-weight: normal;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0.5px;
    width: 4px;
    height: calc(100% - 1px);
    background: $blue;
  }
}
.el-icon-check {
  color: $green;
  padding: 2px;
  border-radius: 50%;
  border: 1px solid $green;
}
.icon_true {
  font-size: 18px;
}
/deep/ .el-icon-circle-check {
  color: green;
}
/deep/ .el-icon-circle-close {
  color: rgba(212, 48, 48, 1);
}
/deep/ .el-dialog__body {
  padding: 20px 60px 30px;
}
/deep/ .el-dialog__footer {
  padding: 10px 60px 30px;
}
.wrapper {
  .under-line {
    display: inline-block;
    min-width: 80px;
    position: relative;
    text-indent: 0;
    margin: 0 10px;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      border: 1px solid #b1aeae;
      left: 0;
      bottom: -2px;
    }
  }
  .indent_2 {
    text-indent: 2em;
  }
  .lh_2 {
    line-height: 2;
  }
  .footer-box {
    text-align: right;
    // .text-box{
    // 	display: inline-block;
    // 	min-width: 100px;
    // }
    // .flex-end{
    // 	display: flex;
    // 	justify-content: end;
    // }
    .end-box {
      display: flex;
      justify-items: end;

      .flex-width {
        width: 40%;
        text-align: left;
        display: flex;
        .text-box {
          flex: 1;
        }
      }
    }
  }
}
.deal-btn {
  width: 290px;
  margin: 40px auto;
}
.banner {
  width: 100%;
  margin: 20px auto 10px;
}
</style>
